import { ActionType, createReducer } from "typesafe-actions";
import { fetchCreativeMappingsFields, clearFilterFields } from "./filters.actions";
import * as actions from "./filters.actions";
import { FilterFields } from "api";
import { fetchSchedulerDefinitions } from "store/features/emailScheduler/definition";

type FiltersAction = ActionType<typeof actions>;

export type FiltersState = Readonly<{
    isProcessing: boolean;
    hasError: boolean;
    // used only for edition
    fields: FilterFields[];
}>;

export const filtersInitialState: FiltersState = {
    isProcessing: false,
    hasError: false,
    fields: [],
};

export const filtersFieldsReducer = createReducer<FiltersState, FiltersAction>(filtersInitialState)
    .handleAction([fetchCreativeMappingsFields.request], (state) => {
        return {
            ...state,
            isProcessing: true,
            hasError: false,
        };
    })
    .handleAction(
        // TODO: scheduler definition must be removed from here after they will be under separate API
        [fetchCreativeMappingsFields.success, fetchSchedulerDefinitions.success],
        (state, { payload: { fields } }) => {
            return {
                ...state,
                isProcessing: false,
                fields,
            };
        }
    )
    .handleAction([fetchCreativeMappingsFields.failure], (state) => {
        return {
            ...state,
            isProcessing: false,
            hasError: true,
        };
    })
    .handleAction([clearFilterFields] as never, () => {
        return filtersInitialState;
    });
